import { useContext } from 'react';

import { CashKeeperContext } from '@/context/cashKeeper/CashKeeperContext';

const useCashKeeper = () => useContext(CashKeeperContext);

export default useCashKeeper;
